import "../vjs-core-hls-ads-ima-dash.js";
import HlsAdapter from "./hls_adapter";
import DashAdapter from "./dash_adapter";

export default class VideoJsAdapter {
  static global(){
    if (arguments.length > 0) {
      return window.videojs(...arguments);
    }

    return window.videojs;
  }

  static noop(){
  }

  static version(){
    return "vjs-core-7.19.2-ads-6-ima-628213d-dash-5.1.1";
  }

  constructor(){
    this._instance = VideoJsAdapter.global(...arguments);
    this._options = [...arguments];
  }

  instance(){
    return this._instance;
  }

  options(){
    return this._options;
  }

  id(){
    return this.instance().id();
  }

  duration(){
    return this.instance().duration();
  }

  currentTime(){
    try {
      return this.instance().currentTime(...arguments);
    } catch(e) {
      return 0;
    }
  }

  error(){
    return this.instance().error(...arguments);
  }

  trigger(){
    return this.instance().trigger(...arguments);
  }

  techName(){
    return this.instance().techName_;
  }

  on(){
    return this.instance().on(...arguments);
  }

  one(){
    return this.instance().one(...arguments);
  }

  off(){
    return this.instance().off(...arguments);
  }

  readyState(){
    return this.instance().readyState(...arguments);
  }

  networkState(){
    return this.instance().networkState(...arguments);
  }

  isFullscreen(){
    return this.instance().isFullscreen(...arguments);
  }

  getVideoPlaybackQuality(){
    return this.instance().getVideoPlaybackQuality(...arguments);
  }

  dispose(){
    return this.instance().dispose(...arguments);
  }

  muted(){
    return this.instance().muted(...arguments);
  }

  play(){
    return this.instance().play(...arguments);
  }

  paused(){
    return this.instance().paused(...arguments);
  }

  pause(){
    return this.instance().pause(...arguments);
  }

  bigPlayButton(){
    return this.instance().bigPlayButton;
  }

  controlBar(){
    return this.instance().controlBar;
  }

  el(){
    return this.instance().el(...arguments);
  }

  imaSetup(){
    this.instance().ima(...arguments);
  }

  imaObject(){
    return this.instance().ima;
  }

  poster(){
    return this.instance().poster(...arguments);
  }

  volume(){
    return this.instance().volume(...arguments);
  }

  hlsObject(){
    if(typeof this._hls === "undefined"){
      this._hls = new HlsAdapter(this.instance());
    }
    return this._hls;
  }

  dashObject(){
    if(typeof this._dash === "undefined"){
      this._dash = new DashAdapter(this.instance());
    }
    return this._dash;
  }

  hasDashObject() {
    return this.dashObject().hasDashObject();
  }

  bitratesObject() {
    if (this.hasDashObject()) {
      return this.dashObject();
    } else {
      return this.hlsObject();
    }
  }

  adsObject(){
    if(typeof this.instance().ads !== "undefined"){
      return this.instance().ads;
    } else {
      return {};
    }
  }

  isContentResuming() {
    return !!this.adsObject().isContentResuming?.();
  }

  masterPlaylist(){
    var hls = this.hlsObject();
    var data = [];
    var playlist = hls.playlistMasterPlaylists();
    playlist.forEach(function(value, index){
      data[index] = {index: index+1, value: value.bandwidth()/ 1000};
    });
    return data;
  }

  levels(){
    return this.masterPlaylist().length;
  }

  level(){
    var ret;
    this.masterPlaylist().forEach(function(segment){
      if(this.currentBandwidth() == segment.value){
        ret = segment.index;
      }
    }.bind(this));
    return ret;
  }

  currentBandwidth(){
    return this.hlsObject().playlistsMediaAttributesBandwidth() / 1000;
  }

  ended(){
    return this.instance().ended();
  }

  freeze(){
    if (typeof this._play === "undefined") {
      this._play = this.instance().play;
      this.instance().play = VideoJsAdapter.noop;
    }
  }

  unfreeze(){
    if (typeof this._play !== "undefined") {
      this.instance().play = this._play;
      this._play = undefined;
    }
  }

  addChild(){
    return this.instance().addChild(...arguments);
  }

  userActive(isActive) {
    this.instance().userActive(isActive);
  }

  hideControlbar(){
    this.controlBar().hide();
  }

  hasStarted() {
    return this.instance().hasStarted();
  }

  static getComponent(){
    return VideoJsAdapter.global().getComponent(...arguments);
  }

  static registerComponent(){
    return VideoJsAdapter.global().registerComponent(...arguments);
  }

  static extend(){
    return VideoJsAdapter.global().extend(...arguments);
  }

  static plugin(){
    return VideoJsAdapter.global().plugin(...arguments);
  }

  static registerPlugin(){
    return VideoJsAdapter.global().registerPlugin(...arguments);
  }

  static formatTime(seconds){
    return VideoJsAdapter.global().formatTime(seconds);
  }

  static isHtml5Supported(){
    return VideoJsAdapter.global().getTech('Html5').isSupported();
  }

  static isMpegUrlSupported(){
    return !!VideoJsAdapter.global().getTech('Html5').nativeSourceHandler.canPlayType('application/x-mpegURL');
  }

  static hlsXhr(){
    if(VideoJsAdapter.global().Hls){
      return VideoJsAdapter.global().Hls.xhr || {};
    }
    return {};
  }

  remainingTime() {
    return this.instance().remainingTime();
  }

  currentSrc() {
    return this.instance().currentSrc();
  }

  hlsPlaylistMedia() {
    if(!this.hasDashObject()) return this.hlsObject().playlists().media();
  }
}
